import type { Dict } from "../core.js";
import type { audience as vi } from "../vi/audience.js";

export const audience: Dict<typeof vi> = {
  title: "Users",
  subtitle: "Pick an app to see its own numbers. Days follow Vietnam time.",
  loadFailed: "Couldn't load user metrics.",
  aggregateNote:
    "the three cards below SUM all apps (a person in two apps is counted twice). Per-app numbers are under « By app ».",
  newUsersInPeriod: "New users ({period})",
  activeNotSummable: "« Active users » can't be summed across sources.",
  dailyTrend: "Daily trend",
  dailyOnlyNote:
    "Daily granularity only. Rolling a distinct count up to weeks or months is not a sum — someone who opens the app all seven days would be counted seven times.",
  noSourcesTitle: "No sources yet.",
  noSourcesBefore: "The worker adds sources to the database on startup — see",
  "col.source": "Source",
  "col.total": "Total",
  "col.new": "New",
  "col.active": "Active",
  "col.activeBasis": "« Active » basis",
  "col.updated": "Updated",
  activeRefusal: "Sources measure it on different bases ({bases}) — adding them up would add two different concepts.",
};
